import createDataContext from './createDataContext';
import * as actions from './actions/uscgSafetyActions';
import { reducer, initialState } from './reducers/uscgSafetyReducer';

export const { Context: UscgSafetyContext, Provider } = createDataContext(
  reducer,
  actions,
  initialState
);
